<div class="wrapper">
  @for (m of menuItems; track m) {
    <div class="menu-card" (click)="menuItemClicked(m)" (keyup.enter)="menuItemClicked(m)" tabindex="0" role="button">
      <div class="menu-box">
        <div style="height:35px;">
          <h2 style="font-size:18px; float:left"> {{m.data.title}} </h2>
          <h2 style="float: right; font-size:14px">${{m.data.price}}</h2>
        </div>
        @if (m.data.showDescription) {
          <div style="float: left;color:#7E7E7E"> {{m.data.description}}</div>
        }
      </div>
    </div>
  }
</div>

